import React, { Component, PureComponent } from "react";
import styles from "./LastRoundResults.scss";
import { Interpolate, translate } from "react-i18next";
import { t, x } from "../../../helpers/localization";
import { getLeagueData, checkWin, getResult } from "../../../helpers/cwars";
import moment from "moment";
import get from "lodash/get";

import { ILastRoundResults, IWarSettings, ICommonInfo } from "../../../Reducers/ReducerClanWars";
import { Button } from "@wg/wows-react-uikit";
import { Result, RESULTS } from "../../UIKit/UIKit";

import VersusHeader from "../VersusHeader/VersusHeader";

import settings from "../../../settings";

export type IProps = {
  data: ILastRoundResults;
  warSettings: IWarSettings;
  commonInfo: ICommonInfo;
  hide: () => void;
};

export type IState = {};

class LastRoundResults extends PureComponent<IProps, IState> {


  clanId = get(window, ['__PRELOADED_STATE__', 'currentAccount', 'clanId'], null);

  getTitle = result => {
    switch (result) {
      case RESULTS.WIN:
        {
          return t('Победа');
        }

      case RESULTS.DEFEAT:
        {
          return t('Поражение');
        }

      case RESULTS.DRAW:
        {
          return t('Ничья');
        }

      default:
        {
          return '';
        }

    }
  };

  getHighLightClass = result => {
    switch (result) {
      case RESULTS.WIN:
        {
          return styles.winHighlight;
        }

      case RESULTS.DEFEAT:
        {
          return styles.defeatHighlight;
        }

      case RESULTS.DRAW:
        {
          return styles.drawHighlight;
        }

      default:
        {
          return '';
        }

    }
  };

  render() {
    const left = get(this.props, ['data', 'results', 0], null);
    const right = get(this.props, ['data', 'results', 1], null);
    const isWin = checkWin(this.props.data.results, this.clanId);
    const result = getResult(this.props.data.results, this.clanId);
    let myResult = null;
    if (!left || !right) {
      return <div className={styles.wrapper}>{'no data'}</div>;
    }
    if (left.clanId === this.clanId) {
      myResult = left;
    }
    if (right.clanId === this.clanId) {
      myResult = right;
    }

    const previousRating = Math.max(myResult.rating - myResult.ratingDelta, 0);

    return <div className={styles.wrapper}>
                <Interpolate className={styles.date} i18nKey={x('Морское сражение %(startDate)s - %(endDate)s')} startDate={moment(this.props.data.startDate).format(settings.formats.date ? settings.formats.date : 'DD.MM')} endDate={moment(this.props.data.endDate).format(settings.formats.date ? settings.formats.date : 'DD.MM')} t={t} />
                <span className={styles.title}>
                    {this.getTitle(result)}
                </span>
                <div className={styles.versus}>
                    {(left && right) ? <VersusHeader left={{
          tag: left.clan.tag,
          color: left.clan.color,
          realm: left.clan.realm,
          score: left.starsCount,
          leagueData: getLeagueData(this.props.warSettings.leagues, this.props.commonInfo.clan.league) //@TODO for medal img
        }} right={{
          tag: right.clan.tag,
          color: right.clan.color,
          realm: right.clan.realm,
          score: right.starsCount,
          leagueData: (right && right.league) ? getLeagueData(this.props.warSettings.leagues, right.league) : getLeagueData(this.props.warSettings.leagues, 1) //@TODO for medal img
        }} /> : null}
                </div>
                {myResult ? <Result result={result} rating={previousRating} ratingDelta={myResult.ratingDelta} reward={get(myResult, ['reward', 'amount'], 0)} /> : null}
                <div className={styles.bottomButton}>
                    <Button onClick={this.props.hide}>
                        {t('Закрыть')}
                    </Button>
                </div>
            </div>;
  }
}

export default LastRoundResults;